// L14 · Exhibit A (SPEC §3, Act V) — AI-judged, never strikes. The last real question:
// "why should anyone believe you are real?" The verdict is the machine at its most sincere,
// and the judge nominates the striking answer as Exhibit A on the certificate. If THIS answer
// is exhibitWorthy it becomes the quote; otherwise an earlier nominated moment (L06/8/9/12)
// already offered still holds — the accumulator keeps the last strong one (§8).
//
// Built on the shared judged-text shell, so the crisis/abuse/timeout safety pipeline is the
// same one every judged level uses.

import { textLevel } from "@/levels/textlevel.ts";
import { L14 as V } from "@/content/voice.ts";
import type { Level } from "@/levels/types.ts";

export const L14: Level = textLevel({
  id: "L14",
  act: 5,
  title: "Exhibit A",
  prompt: V.prompt,
  placeholder: V.placeholder,
  submit: V.submit,
  charLimit: V.charLimit,
  fallbacks: V.fallbacks,
  decide: (r, answer) => ({
    result: {
      pass: true, // Act V never strikes (§3)
      verdict: r.verdict,
      traits: r.traits, // unguarded / self-aware, from the judge
      quote: r.exhibitWorthy ? answer : undefined,
    },
  }),
});
